import { Component } from '@angular/core'
import { SharedService } from '../../../../services/shared.service'
import { VehicleDocumentsService } from '../../../../services/vehicle-documents.service'

import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { CustomerPortalSharedModule } from '@inside-hub-app/customer-portal-shared'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { NgxGlideModule } from 'ngx-glide'
import { GoogleMapsModule } from '@angular/google-maps'
import { A11yModule } from '@angular/cdk/a11y'
import { TextFieldModule } from '@angular/cdk/text-field'
@Component({
  selector: 'customer-portal-app-unread-document',
  standalone: true,
  templateUrl: './unread-document.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomerPortalSharedModule,
    HubChildTranslateModule,
    NgxSkeletonLoaderModule,
    NgxGlideModule,
    GoogleMapsModule,
    A11yModule,
    TextFieldModule
  ]
})
export class UnreadDocumentComponent {
  unread = 0

  sub = {
    onUnreadMyDocuments: null
  }

  constructor (
    public sharedService: SharedService,
    private readonly vehicleDocumentsService: VehicleDocumentsService
  ) {
    this.sub.onUnreadMyDocuments =
      this.vehicleDocumentsService.onUnreadMyDocuments.subscribe(count => {
        this.unread = count
      })
  }
}
